import { HttpApiEndpoint, HttpApiError, HttpApiGroup } from "@effect/platform";
import { DatabaseError, DataIntegrityError } from "../auth/errors";
import { Authorization } from "../auth/middleware";
import {
  NotifyPresenceInput,
  NotifyTypingInput,
  PublishNotificationResponse,
} from "../models/team/notification";

export const TeamNotificationGroup = HttpApiGroup.make("team-notification")
  .add(
    HttpApiEndpoint.post("notifyTyping", "/notifications/typing")
      .middleware(Authorization)
      .setPayload(NotifyTypingInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .add(
    HttpApiEndpoint.post("notifyPresence", "/notifications/presence")
      .middleware(Authorization)
      .setPayload(NotifyPresenceInput)
      .addSuccess(PublishNotificationResponse)
      .addError(HttpApiError.Forbidden)
      .addError(HttpApiError.ServiceUnavailable)
      .addError(HttpApiError.InternalServerError)
      .addError(DatabaseError)
      .addError(DataIntegrityError),
  )
  .prefix("/api");
